import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRegisterValues } from 'elements/Account/providers/RegisterProvider';
import { InfoBlock } from 'components/Shared/InfoBlock';
import { Tooltip } from 'components/Shared/Tooltip';
import { Form, FormItem } from 'components/UI/Form';
import { Input } from 'components/UI/Input';
import { useReturnFormFields } from '../../../hooks/useReturnFormFields';
import { RegisterSpinner } from '../RegisterSpinner';
import { useAppSelector } from 'appRedux/hooks';
import { AccountFormFields } from 'constants/account/account-form-fields';

export const RegisterCompanyPhaseTwo = () => {
  const { form } = useRegisterValues();
  const { t } = useTranslation();
  const formFields = useReturnFormFields(form, [
    AccountFormFields.Password,
    AccountFormFields.PasswordConfirmation,
    AccountFormFields.UserName
  ]);
  const { loading: companyLoading, data: companyData } = useAppSelector(
    ({ company }) => company
  );
  const [isCompanyDataPresent, setIsCompanyDataPresent] = useState(false);

  useEffect(() => {
    if (Object.keys(companyData).length > 0) {
      setIsCompanyDataPresent(true);
      form.setFieldsValue({
        terms_and_conditions: true,
        email: companyData.contact_email
      });
    }
  }, [companyData]);

  return companyLoading ? (
    <RegisterSpinner />
  ) : isCompanyDataPresent ? (
    <Form layout="vertical" form={form} name="registerCompany">
      {formFields.map(field => (
        <Fragment key={field.name}>
          <FormItem
            label={
              <>
                {field.label}
                {field.tooltip && <Tooltip>{field.tooltip}</Tooltip>}
              </>
            }
            name={field.name}
            rules={field.rules}
            isWhitespaceForbidden={
              field.type !== 'password' &&
              field.name !== AccountFormFields.UserName
            }
          >
            {field?.type === 'password' ? <Input type="password" /> : <Input />}
          </FormItem>
        </Fragment>
      ))}
    </Form>
  ) : (
    <InfoBlock
      type="contrast"
      title={t('account.wrongToken')}
      imageType="empty"
    />
  );
};
